export enum ForeignCurrencyDrawerMode {
  EDIT_MODE = 'edit',
  ADD_MODE = 'add',
}
